<div *appLoader="!unallowedAttachmentFileTypesSig()">
  <div
    class="drop-zone"
    appDropzone
    (hovered)="toggleHover($event)"
    (dropped)="processFiles($event)"
    [class.hovering]="isHovering"
  >
    <div class="center-container">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
    </div>

    <div class="center-container">
      <p class="drag-and-drop-text">
        {{ 'drag' | translate }} {{ 'and' | translate }} {{ 'drop' | translate }}
        {{ 'or ' | translate }}
      </p>
      <br />
      <p class="choose-files-text" (click)="fileUpload.click()">
        {{ 'choose' | translate }} {{ 'a' | translate }} {{ 'file' | translate }}
      </p>
    </div>

    <input
      type="file"
      multiple
      class="file-input cdk-visually-hidden"
      (change)="onFileSelected($event)"
      #fileUpload
    />
    <form [formGroup]="form" class="form-container">
      @for (formField of form.attachmentControls; track formField; let i = $index) {
        <div formArrayName="attachments" class="form-container-row">
          <div class="file-details">
            <app-ui-input
              class="input"
              [control]="formField.name"
              color="primary"
              [label]="'name' | translate"
            ></app-ui-input>
            <div class="file-size">
              {{ formField.value.file?.size / (1024 * 1024) | number: '1.0-1' }}MB
            </div>
          </div>
          <app-ui-select
            [control]="formField.categories"
            [options]="attachmentCategories()"
            color="primary"
            [label]="'attachmentCategories' | translate"
          ></app-ui-select>
          <mat-icon class="delete-icon" (click)="deleteFile(i)">delete</mat-icon>
        </div>
      }
    </form>
  </div>
</div>
@if (totalFilesSize > 0) {
  <div class="file-size-info" [ngClass]="{ 'size-exceeded': isFileSizeExceeded }">
    <span>
      {{ 'totalSize' | translate }}: {{ totalFilesSize / (1024 * 1024) | number: '1.0-1' }}MB /
      {{ MAX_FILE_SIZE_MB }}MB
    </span>
    @if (isFileSizeExceeded) {
      <div class="size-warning">
        {{
          'fileSizeExceeded'
            | translate: { maxSizeMB: MAX_FILE_SIZE_MB, exceededByMB: exceededByMB }
        }}
      </div>
    }
  </div>
}
<div class="button-container">
  <app-ui-button
    [text]="'cancel' | translate"
    buttonType="secondary"
    (click)="dialogRef.close()"
  ></app-ui-button>
  <app-ui-button
    class="save-button"
    text="{{ 'save' | translate }}"
    actionType="submit"
    (click)="upload()"
    [disabled]="isFileSizeExceeded"
  ></app-ui-button>
</div>
